import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../Admin/EditButtons';
import DownloadRequestEditStatus from './Status';
import DownloadRequestEditStatusHistory from './StatusHistory';

import { getFileSizeDescription } from '../../helpers/Files';

import ErrorBoundary from '../ErrorBoundary';
import DownloadRequestEditReasonContent from './ReasonContent';

const DownloadRequestEditMainEdit = ({
  selectedFileSizes,
  profile,
  fileSizes,
  downloadRequest,
  errors,
  saving,
  handleSave,
  handleChange,
  handleDelete,
}) => {
  const intl = useIntl();

  const isFileSizeChecked = (fileSizeId) => selectedFileSizes.find(
    sfs => (`${sfs.id}` === `${fileSizeId}`),
  ) || false;

  // const handleKeyPress = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault();
  //     handleSave();
  //   }
  // };

  const lastStatus = downloadRequest.statuses.length > 0 ? downloadRequest.statuses[0] : null;

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div className="group-profile">
          <Row>
            <Col className="download-details">
              {(profile.is_admin && downloadRequest.created_at) && (
                <p className="requested-by">
                  <strong>{intl.formatMessage({ defaultMessage: 'Requested by:' })}</strong><br />
                  {downloadRequest.user ? (
                    <Fragment>
                      {downloadRequest.user.name}<br />
                      <span className="requested-by-email">
                        {downloadRequest.user.email}
                      </span>
                    </Fragment>
                  ) : (
                    intl.formatMessage({ defaultMessage: '(removed user)' })
                  )}
                </p>
              )}
              {downloadRequest.reason && (
                <p>
                  <strong>{intl.formatMessage({ defaultMessage: 'Reason for request:' })}</strong><br />
                  {typeof downloadRequest.reason === 'object' ?
                    <DownloadRequestEditReasonContent reason={downloadRequest.reason} /> :
                    downloadRequest.reason}
                </p>
              )}
              <FormGroup>
                <strong>{intl.formatMessage({ defaultMessage: 'Requested file sizes:' })}</strong>
                <ul className="file-sizes-list">
                  <li>
                    <div className="checkbox-wrapper">
                      <Input
                        type="checkbox"
                        className="input-check check-l"
                        id="file-size-edit-0"
                        name="file_sizes"
                        value="original"
                        disabled={!profile.is_admin || downloadRequest.status === 'accepted'}
                        defaultChecked={isFileSizeChecked('original')}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="checkbox-label">
                      <Label htmlFor="file-size-edit-0">
                        {intl.formatMessage({ defaultMessage: 'Original size' })}
                      </Label>
                    </div>
                  </li>
                  {fileSizes.map(fs => (
                    <li key={fs.id}>
                      <div className="checkbox-wrapper">
                        <Input
                          type="checkbox"
                          className="input-check check-l"
                          id={`file-size-edit-${fs.id}`}
                          name="file_sizes"
                          value={fs.id}
                          disabled={!profile.is_admin || downloadRequest.status === 'accepted'}
                          defaultChecked={isFileSizeChecked(fs.id)}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="checkbox-label">
                        <Label htmlFor={`file-size-edit-${fs.id}`}>
                          {fs.name}
                          <span>{getFileSizeDescription(fs)}</span>
                        </Label>
                      </div>
                    </li>
                  ))}
                </ul>
                {errors.includes('file_sizes') && (
                  <div className="error">
                    {intl.formatMessage({ defaultMessage: 'You have to select at least one file size' })}
                  </div>
                )}
              </FormGroup>
              <FormGroup>
                <strong>{intl.formatMessage({ defaultMessage: 'Status:' })}</strong><br />
                <DownloadRequestEditStatus
                  downloadRequest={downloadRequest}
                  isAdmin={profile.is_admin}
                  handleChange={handleChange}
                />
              </FormGroup>
              {profile.is_admin && (
                <FormGroup>
                  <Label for="inpComment">{intl.formatMessage({ defaultMessage: 'Comment' })}</Label>
                  <Textarea
                    name="comment"
                    id="inpComment"
                    className="form-control"
                    placeholder={intl.formatMessage({ defaultMessage: 'Comment for requester (optional)' })}
                    value={downloadRequest.comment || ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              )}
              {(lastStatus && lastStatus.comment && !profile.is_admin) && (
                <p>
                  <strong>{intl.formatMessage({ defaultMessage: 'Admin comment' })}</strong>:<br />
                  {lastStatus.comment}
                </p>
              )}
            </Col>
            <Col className="download-status-history">
              <DownloadRequestEditStatusHistory
                statuses={downloadRequest.statuses}
              />
            </Col>
          </Row>
        </div>
      </div>
      {profile.is_admin && (
        <AdminEditButtons
          saving={saving}
          deleteText={intl.formatMessage({ defaultMessage: 'Delete download request' })}
          handleDelete={handleDelete}
          handleSave={handleSave}
        />
      )}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  fileSizes: state.App.fileSizes,
});

DownloadRequestEditMainEdit.propTypes = {
  profile: PropTypes.object.isRequired,
  fileSizes: PropTypes.array.isRequired,
  downloadRequest: PropTypes.object.isRequired,
  selectedFileSizes: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(DownloadRequestEditMainEdit);
